import React from 'react';
import { NavLink } from 'react-router-dom';
import media from '../../media';

const Publications = (props) => (
    <div className="row justify-content-center">
        <div className="col-md-10">
            <h2 className="display-4 text-center">Публикации на книги, финансирани от проекта</h2>
            <p className="text-center">Ще издадем неиздаваната досега Поп-Йоанова преправка от 1830 г. и Рилската преправка от 1825 г., която вече е публикувана, но с твърде анахронична издателска стратегия. Правата за отпечатване на двете книги вече са откупени от Националната библиотека „Св. св. Кирил и Методий“ в София.</p>
        </div>
        <div className="col-md-6">
            <div className="card flex-md-row mb-4 box-shadow h-md-250">
                <div className="card-body d-flex flex-column align-items-start">
                <strong className="d-inline-block mb-2 text-danger">Ръкопис № НБКМ 775</strong>
                <h3 className="mb-0">
                    <a className="text-dark" href="#">Рилска преправка</a>
                </h3>
                <div className="mb-1">(Рилски манастир, 1825, монах Паисий Рилски)</div>
                <p className="card-text mb-auto text-justify">Книгата е уникална за ръкописната „Паисиада“. Това е първата възрожденска преправка на Паисиевата история, която е достигнала до нас. Именно тази ръкописна книга поставя началото на преправянето на Паисиевата „История славянобългарска“.</p>
                <NavLink to="/rilska-prepravka" className="text-danger">Научете повече за ръкописа</NavLink>
                </div>
                <img className="card-img-right flex-auto d-none d-lg-block" data-src="holder.js/200x250?theme=thumb" alt="Thumbnail [200x250]" style={{width: 170, height: 250}} src={media['rilska_cover']} data-holder-rendered="true"/>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card flex-md-row mb-4 box-shadow h-md-250">
                <div className="card-body d-flex flex-column align-items-start">
                <strong className="d-inline-block mb-2 text-danger">Ръкопис № НБКМ 1113</strong>
                <h3 className="mb-0">
                    <a className="text-dark" href="#">Поп-Йоанова преправка</a>
                </h3>
                <div className="mb-1">(село Змеево, 1830, поп Йоаникия Петкович)</div>
                <p className="card-text mb-auto text-justify">Това е едната от достигналите до нас две ръкописни книги, които единствено пряко възхождат към Рилската преправка.</p>
                <NavLink to="/pop-yoanova-prepravka" className="text-danger">Научете повече за ръкописа</NavLink>
                </div>
                <img className="card-img-right flex-auto d-none d-lg-block" data-src="holder.js/200x250?theme=thumb" alt="Thumbnail [200x250]" style={{width: 170, height: 250}} src={media['popyoanova_cover']} data-holder-rendered="true"/>
            </div>
        </div>
    </div>
);

export default Publications


// WEBPACK FOOTER //
// ./src/views/Home/publications.block.jsx